import { Component, OnInit, Input } from '@angular/core';
import { IListDataView, ListViewDataType } from '../models/list-data-view';

@Component({
  selector: 'ngx-list-data-view',
  templateUrl: './ngx-list-data-view.component.html',
  styleUrls: ['./ngx-list-data-view.component.scss']
})
export class NgxListDataViewComponent implements OnInit {

  @Input() items: IListDataView[] = [];

  _fieldType: typeof ListViewDataType = ListViewDataType;

  constructor() { }

  ngOnInit(): void {
  }

}
